import { Component, Vue } from 'vue-property-decorator';
import { IAgency } from 'admiral-core';

@Component
export class PermissionMixin extends Vue {
  get currentAgency(): IAgency {
    return this.$store.state.DataModule.agency;
  }

  hasAgencyPermission(permissionKey: string) {
    return !!this.currentAgency.plan?.permissions[permissionKey];
  }
}
